import { render, staticRenderFns } from "./CategoryAddForm.vue?vue&type=template&id=577cf966&lang=html&"
import script from "./CategoryAddForm.vue?vue&type=script&lang=js&"
export * from "./CategoryAddForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports